import { useQuery } from '@tanstack/react-query';
import { fetchUsers, fetchUser } from './request';
import { USERS_QUERY_KEY, USER_QUERY_KEY } from './key';

export const useUsers = () => {
  return useQuery({
    queryKey: [USERS_QUERY_KEY],
    queryFn: fetchUsers,
  });
};

export const useUser = (id?: string) => {
  return useQuery({
    queryKey: [USER_QUERY_KEY, id],
    queryFn: () => fetchUser(id!),
    enabled: !!id,
    retry: false,
  });
};
